import { render } from "./ProviderInvoiceDiffModal.vue?vue&type=template&id=7689ac52&ts=true"
import script from "./ProviderInvoiceDiffModal.vue?vue&type=script&lang=ts"
export * from "./ProviderInvoiceDiffModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__